import { createFormPoster } from '@bigcommerce/form-poster';
import { createRequestSender } from '@bigcommerce/request-sender';

import {
    CustomerStrategyFactory,
    toResolvableModule,
} from '@bigcommerce/checkout-sdk/payment-integration-api';

import GooglePayAuthorizeNetGateway from '../../gateways/google-pay-authorizenet-gateway';
import GooglePayCustomerStrategy from '../../google-pay-customer-strategy';
import GooglePayPaymentProcessor from '../../google-pay-payment-processor';
import createGooglePayScriptLoader from '../create-google-pay-script-loader';

const createGooglePayAuthorizeDotNetCustomerStrategy: CustomerStrategyFactory<
    GooglePayCustomerStrategy
> = (paymentIntegrationService) => {
    const useRegistryV1 = !paymentIntegrationService.getState().getStoreConfig()?.checkoutSettings
        .features['INT-5659.authorizenet_use_new_googlepay_customer_strategy'];

    if (useRegistryV1) {
        throw new Error('googlepayauthorizenet requires using registryV1');
    }

    return new GooglePayCustomerStrategy(
        paymentIntegrationService,
        new GooglePayPaymentProcessor(
            createGooglePayScriptLoader(),
            new GooglePayAuthorizeNetGateway(paymentIntegrationService),
            createRequestSender(),
            createFormPoster(),
        ),
    );
};

export default toResolvableModule(createGooglePayAuthorizeDotNetCustomerStrategy, [
    { id: 'googlepayauthorizenet' },
]);
